import React, { useEffect } from 'react';
import { DirectoryBar } from '../components/DirectoryBar';
import { H3 } from '../components/H3';
import { Section } from '../components/Section';
import { BRAZE_EVENT } from '../constants/braze';
import { Bridge } from '../plugins/bridge';

const data = [
  {
    id: 1,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-01.jpg/ss23-lookbook-women-01.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 2,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-02.jpg/ss23-lookbook-women-02.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 3,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-03.jpg/ss23-lookbook-women-03.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 4,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-04.jpg/ss23-lookbook-women-04.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 5,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-05.jpg/ss23-lookbook-women-05.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 6,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-06.jpg/ss23-lookbook-women-06.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 7,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-07.jpg/ss23-lookbook-women-07.jpg/carhartt%3Alooksbigimage',
  },

  {
    id: 8,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-08.jpg/ss23-lookbook-women-08.jpg/carhartt%3Alooksbigimage',
  },

  {
    id: 9,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-09.jpg/ss23-lookbook-women-09.jpg/carhartt%3Alooksbigimage',
  },

  {
    id: 10,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-10.jpg/ss23-lookbook-women-10.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 11,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-11.jpg/ss23-lookbook-women-11.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 12,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-12.jpg/ss23-lookbook-women-12.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 13,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-13.jpg/ss23-lookbook-women-13.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 14,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-14.jpg/ss23-lookbook-women-14.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 15,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-15.jpg/ss23-lookbook-women-15.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 16,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-16.jpg/ss23-lookbook-women-16.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 17,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-17.jpg/ss23-lookbook-women-17.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 18,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-18.jpg/ss23-lookbook-women-18.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 19,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-19.jpg/ss23-lookbook-women-19.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 20,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-20.jpg/ss23-lookbook-women-20.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 21,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-21.jpg/ss23-lookbook-women-21.jpg/carhartt%3Alooksbigimage',
  },
  {
    id: 22,
    img: 'https://www.carhartt-wip.com/binaries/content/gallery/pagetypes/looks/detail/women/2023fw/ss23-lookbook-women-22.jpg/ss23-lookbook-women-22.jpg/carhartt%3Alooksbigimage',
  },
];

export const LookbookWomenPage = () => {
  useEffect(()=>{
    const contentInfo = {
      content_tab : '룩북',
      content_id : '2023 FW WOMAN',
      content_name : '2023 FW WOMAN'
    }
    Bridge.sendAmplitude('contend_viewed', contentInfo);
    Bridge.sendBraze(BRAZE_EVENT.CONTENT_VIEWED, contentInfo);
  },[]);
  
  return (
    <div
      style={{ backgroundColor: '#fff' }}
      className="-mx-4 -mt-6 md:px-16 text-black"
    >
      <DirectoryBar
        text="Home 가을/겨울 2023 - 여성"
        className="hidden md:block border-0 mt-6 text-black"
      />

      <H3 className="font-bold text-center pt-20 md:pt-0 pb-20 text-black">
        가을/겨울 2023 - 여성
      </H3>

      <Section className="space-y-24 pb-24">
        <div className="grid md:grid-cols-2 gap-16">
          {data.map((item) => (
            <img src={item.img} alt="" className="w-full h-full object-cover" />
          ))}
        </div>
      </Section>
    </div>
  );
};
